<template>
    <div>

		<div class="row">
			<div class="col-xs">
				<button class="button-edit" @click="close">
					<i class="fa fa-arrow-left"></i> Voltar
				</button>
				<br/><br/>
			</div>
		</div>

        <div class="row" v-if="current === 'new'">
			<div class="col-xs">
				<FormInput v-model="document" label="CNPJ" icon="fa-building" />
			</div>
		</div>

        <div class="row">
			<div class="col-xs">
				<FormInput v-model="name" label="Nome" icon="fa-building" />
			</div>
		</div>
    
        <button class="button-create" @click="save" :disabled="loading">
			<i v-if="!loading" class="fa fa-fw fa-save"></i> 
            <i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i> 
            Salvar
		</button>

    </div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";

export default {
    name: "AdminCompanyDocumentForm",

    props: [ "current", "company" ],

    components: { FormInput },

    data() {
        return {
            loading: false,
            name: "",
            document: "",
        };
    },

    mounted() {
        if (this.current !== 'new') {
            this.name = this.current.name;
            this.document = this.current.document;
        }
    },

    methods: {
        async save() {
            const delta = {};

            if (this.current === 'new') {

                delta.name = this.name;
                delta.document = this.document;
                delta.company_id = this.company.id;

                this.loading = true;
                const res = await Api.post_admin("company/add-document", delta);
                this.loading = false;

                if (res.error) {
                    this.$notification.error(res.data);
                    return;
                }
                this.$notification.success("Salvo com sucesso.");
                this.$emit('load');
                this.close();
                
            } else {

                if (this.current.name != this.name) delta.name = this.name;
                if (Object.keys(delta).length == 0) return;

                delta.id = this.current.id;

                this.loading = true;
                const res = await Api.post_admin("company/update-document", delta);
                this.loading = false;

                if (res.error) {
                    this.$notification.error(res.data);
                    return;
                }
                this.$notification.success("Salvo com sucesso.");
                this.$emit('load');
                this.close();
                
            }
        },

        close() {
            this.$emit("close");
        }
    }
}
</script>

<style scoped>
    .button-create {
        float: right;
    }
</style>